var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list-page" }, [
    _c("header", { staticClass: "list-head" }, [
      _c("div", { staticClass: "head-orn" }, [_vm._v("✿")]),
      _c("h1", { staticClass: "head-title" }, [_vm._v("信 箱")]),
      _c("div", { staticClass: "head-sub" }, [
        _vm._v(
          "共 " + _vm._s(_vm.listData.length) + " 封 · 每一封都值得慢慢读"
        ),
      ]),
    ]),
    _vm.loading
      ? _c("div", { staticClass: "list-loading" }, [
          _c("span", { staticClass: "dot" }),
          _c("span", { staticClass: "dot" }),
          _c("span", { staticClass: "dot" }),
        ])
      : _c(
          "div",
          { staticClass: "list-items" },
          _vm._l(_vm.listData, function (item, index) {
            return _c(
              "div",
              {
                key: item.key,
                staticClass: "list-item",
                class: { special: item.special, fight: item.fight },
                style: { animationDelay: 0.1 + index * 0.1 + "s" },
                on: {
                  click: function ($event) {
                    return _vm.handleView(item.path)
                  },
                },
              },
              [
                item.tag
                  ? _c("div", { staticClass: "item-tag" }, [
                      _vm._v(_vm._s(item.tag)),
                    ])
                  : _vm._e(),
                _c("h2", { staticClass: "item-title" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _c("p", { staticClass: "item-description" }, [
                  _vm._v(_vm._s(item.description)),
                ]),
                _c("div", { staticClass: "item-meta" }, [
                  _c("span", { staticClass: "publish-time" }, [
                    _vm._v("🕐 " + _vm._s(item.publishTime)),
                  ]),
                  _c("span", { staticClass: "read-more" }, [
                    _vm._v("阅读全文 ›"),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
    _c("div", { staticClass: "list-foot" }, [
      _vm.loadFailed
        ? _c("span", { staticClass: "foot-warn" }, [
            _vm._v(
              "· 内容服务未连接（" +
                _vm._s(_vm.loadError) +
                "），正在展示内置文案 ·"
            ),
          ])
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "foot-link",
          on: {
            click: function ($event) {
              return _vm.handleView("/rose")
            },
          },
        },
        [_vm._v("🌹 红玫瑰（点击绽放版）")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }